export enum OnDemandScenarioEnum {
  OnGoingCase = 1,
  ReachedLimit = 2,
  NoNeedToRetakeSurvey = 3,
  NeedToRetakeSurvey = 4
}
